import React from "react";
import { CalendarCheck, CheckCircle2, CircleSlash2, ShieldCheck, Users } from "lucide-react";

const Metric = ({ testId, icon: Icon, label, value, accent }) => (
  <div data-testid={testId} className="border-y border-slate-800 bg-white/[0.025] px-4 py-4 transition-colors duration-200 hover:bg-white/[0.045]">
    <div className="flex items-center justify-between">
      <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-500">{label}</span>
      <Icon className={`h-4 w-4 ${accent}`} />
    </div>
    <strong className="mt-3 block text-3xl font-bold text-white">{value}</strong>
  </div>
);

export const AttendanceReportSummary = ({ summary }) => {
  const frequency = Number(summary?.frequency_pct || 0);
  const absenceShare = Math.max(0, 100 - frequency);
  return (
    <div className="grid gap-3 md:grid-cols-3 xl:grid-cols-[repeat(5,minmax(0,1fr))_220px]" data-testid="attendance-summary">
      <Metric testId="attendance-total-sessions" icon={CalendarCheck} label="Sessões" value={summary?.total_sessions || 0} accent="text-sky-300" />
      <Metric testId="attendance-total-members" icon={Users} label="Irmãos" value={summary?.total_members || 0} accent="text-indigo-300" />
      <Metric testId="attendance-total-present" icon={CheckCircle2} label="Presenças" value={summary?.present_records || 0} accent="text-emerald-400" />
      <Metric testId="attendance-total-absent" icon={CircleSlash2} label="Faltas" value={summary?.absence_records || 0} accent="text-rose-400" />
      <Metric testId="attendance-total-justified" icon={ShieldCheck} label="Justificadas" value={summary?.justified_records || 0} accent="text-amber-300" />
      <div className="flex items-center gap-4 border-y border-[#D4AF37]/30 bg-[#D4AF37]/5 px-4 py-3" data-testid="attendance-overall-frequency">
        <div
          className="relative grid h-20 w-20 shrink-0 place-items-center rounded-full"
          style={{ background: `conic-gradient(#10B981 0 ${frequency}%, #EF4444 ${frequency}% ${frequency + absenceShare}%)` }}
        >
          <div className="grid h-14 w-14 place-items-center rounded-full bg-[#0B0F19] text-sm font-bold text-white">{frequency}%</div>
        </div>
        <div>
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#D4AF37]">Frequência geral</span>
          <p className="mt-1 text-xs leading-relaxed text-slate-400">{summary?.eligible_records || 0} registros elegíveis</p>
        </div>
      </div>
    </div>
  );
};